import { gql } from '@apollo/client'

export const ROLES_QUERY = gql`
  query Roles($filters: RoleFilters!) {
    roles(filters: $filters) {
      roleID
      displayRoleID
      name
      entityType
      description
      isActive
      canManage
    }
  }
`

export const ROLE_MANAGEMENT_SCOPE_QUERY = gql`
  query RoleManagementScope {
    roleManagementScope {
      unrestricted
      creatableEntityTypes
      grantablePermissionIDs
    }
  }
`

export const AUDIT_LOG_ROLE_NAMES_QUERY = gql`
  query AuditLogRoleNames($filters: RoleFilters!) {
    roles(filters: $filters) {
      name
    }
  }
`

export const ROLE_QUERY = gql`
  query Role($roleID: String!) {
    role(roleID: $roleID) {
      roleID
      name
      description
      isActive
      entityType
      canManage
      permissions {
        permissionName
        subPermissions {
          name
          actions {
            permissionID
            action
            selected
            disabled
          }
        }
      }
    }
  }
`
export const CREATE_ROLE_MUTATION = gql`
  mutation CreateRole($input: CreateRoleInput!) {
    createRole(input: $input) {
      message
    }
  }
`
export const UPDATE_ROLE_MUTATION = gql`
  mutation UpdateRole($input: UpdateRoleInput!) {
    updateRole(input: $input) {
      message
    }
  }
`
export const DELETE_ROLE_MUTATION = gql`
  mutation DeleteRole($roleID: String!) {
    deleteRole(roleID: $roleID) {
      message
      userAffected
    }
  }
`
